import { fetchEducation } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import EducationCard from "./EducationCard";
const Education = () => {
  const navigate = useNavigate();
  const navigateToPage = (path: string) => {
    navigate(path);
  };
  const { data: education = [] } = useQuery({
    queryKey: ["education"],
    queryFn: fetchEducation,
  });
  return (
    <div id="education" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-2 text-teal">
          Education
        </h2>
        <p className="text-gray-400 mb-6">
          A brief look at my educational background.
        </p>
      </div>

      <div className="relative mb-8">
        {/* Timeline line */}
        <div className="absolute left-0 top-0 bottom-0 w-px bg-gray-700"></div>

        {education.map((educationData, index) => (
          <EducationCard
            key={educationData.id}
            education={educationData}
            index={index}
            showDescription={false}
          />
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <Button
          onClick={() => navigateToPage("/education")}
          className="bg-teal hover:bg-teal-dark text-navy-dark flex items-center gap-2"
        >
          View More
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Education;
